import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Button, Grid } from "@mui/material";
import IllustrationOffering from "../../../media/site_media/onboarding/IllustrationOffering@3x.png";
import FormControl from "@mui/material/FormControl";
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
import { decode } from 'html-entities';
import GreenInfo from '../../../media/site_media/illustrations/IconControlsInfo_Green@3x.png';
import '../../SelfServe/SelfServe.css';
import { IoClose } from "react-icons/io5";
import Modal from '@mui/material/Modal';
// import {Helmet} from 'react-helmet'
import IconHelp from '../../../media/site_media/illustrations/Icon-Help@2x.png';
import { Navigation, Pagination, Mousewheel } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Switch, FormGroup, FormControlLabel, Accordion, AccordionSummary, AccordionDetails } from '@mui/material';
import { styled } from '@mui/material/styles';
import CircularProgress from "@mui/material/CircularProgress";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import { PiInfoBold } from "react-icons/pi";
import { windowTime } from 'rxjs';

const AntSwitch = styled(Switch)(({ theme }) => ({
   width: 42,
   height: 24,
   marginLeft: 5,
   padding: 0,
   display: 'flex',
   '&:active': {
      '& .MuiSwitch-thumb': {
         width: 24,
      },
      '& .MuiSwitch-switchBase.Mui-checked': {
         transform: 'translateX(9px)',
      },
   },
   '& .MuiSwitch-switchBase': {
      padding: 2,
      '&.Mui-checked': {
         transform: 'translateX(17px)',
         color: '#fff !important',
         '& + .MuiSwitch-track': {
            opacity: 1,
            backgroundColor: 'var(--brand-color)',
         },
      },
   },
   '& .MuiSwitch-thumb': {
      boxShadow: '0 2px 4px 0 rgb(0 35 11 / 20%)',
      width: 20,
      height: 20,
      borderRadius: 40,
      transition: theme.transitions.create(['width'], {
         duration: 200,
      }),
   },
   '& .MuiSwitch-track': {
      borderRadius: 100,
      opacity: 1,
      backgroundColor:
         theme.palette.mode === 'dark' ? 'rgba(255,255,255,.35)' : 'rgba(0,0,0,.25)',
      boxSizing: 'border-box',
   },
}));

const DarkTooltip = styled(({ className, ...props }) => (
   <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
   [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: '#222222 !important',
      color: '#ffffff',
      boxShadow: theme.shadows[1],
      fontSize: 11,
      margin: '0px'
   },
}));

export default function MembershipOffering(props) {
   const { t } = useTranslation();
   const [openOneTierWarning, setOpenOneTierWarning] = useState(false);
   const [openTrialLengthWarning, setOpenTrialLengthWarning] = useState(false);
   const [tempTrialLength, setTempTrialLength] = useState('');
   const [isLoading, setIsLoading] = useState(true)

   useEffect(() => {
      if (props.tiersModal === true) {
         setIsLoading(false)
      } else {
         setIsLoading(true)
      }
   }, [props.tiersModal])
   // const [trialLength, setTrialLength] = useState(7);
   const trial_length_values = [
      0,
      1,
      3,
      5,
      7,
      10,
      14,
   ]
   const handleEditOffering1 = () => {
      props.setEditOffering('1');
      // Perform additional actions if needed
   };
   const handleEditOffering2 = () => {
      props.setEditOffering('2');
      // Perform additional actions if needed
   };


   const TierAccordion = (props) => {
      const {
         tierName,
         annualActive,
         yearlyPrice,
         monthlyActive,
         monthlyPrice,
         perksText,
         currencySymbol,
         openEditTier,
         setTiersModal,
         currencySymbolPost,
         async,
         asyncPrice2Rebill,
         asyncPrice2Time
      } = props;
      const [expanded, setExpanded] = useState(true);

      const handleAccordionChange = () => {
         // setExpanded(!expanded);
      };
      let rebill_wording = ''
      if (asyncPrice2Rebill === true) {
         rebill_wording = t('onboarding.setupOffering.rebill')
      } else {
         rebill_wording = t('onboarding.setupOffering.noRebill')
      }
      const getAsyncLabel = (asyncPrice2Time, isLarge) => {
         if (asyncPrice2Time === 'forever') return t('onboarding.setupOffering.forever');
         const parts = asyncPrice2Time.match(/^(\d+)\s+(week|month|year)s?$/i);
         if (!parts) return '';
         const count = parseInt(parts[1]);
         const unit = parts[2].toLowerCase();
         const durKey = count === 1 ? `1${unit}` : `${count}${unit}s`;
         const durTranslated = t(`durationLabels.${durKey}`, asyncPrice2Time);
         const shortDur = `${count}${unit[0]}`;
         const periodAbbrev = unit === 'week' ? 'p/w' : unit === 'month' ? 'p/m' : 'p/y';
         return isLarge
            ? ` ${periodAbbrev} (${durTranslated} ${rebill_wording})`
            : ` ${periodAbbrev} (${shortDur} ${rebill_wording})`;
      };
      return (
         <div id="offering_accord">
            <Accordion expanded={expanded} onChange={handleAccordionChange} sx={{
               '.MuiAccordionSummary-root': {
                  borderTopLeftRadius: '8px',
                  borderTopRightRadius: '8px',
                  maxHeight: '80px',
                  webkitTapHighlightColor: 'none',
                  marginTop: props.windowWidth < 900 ? '20px' : '',
               },
               '.MuiAccordionSummary-root.Mui-focusVisible': {
                  backgroundColor: '#dee4ec',
               },
               '.MuiPaper-root-MuiAccordion-root:before': {
                  opacity: '0',
               },
               '.MuiAccordion-root:before': {
                  display: 'none',
               },
               boxShadow: 'none',
               '& .MuiAccordionSummary-root': {
                  boxShadow: 'none !important',
               },
               '& .MuiPaper-root.MuiAccordion-root:before': {
                  boxShadow: 'none !important',
               },
               '& .MuiAccordion-root:before': {
                  boxShadow: 'none !important',
               },
            }}>
               <AccordionSummary
                  expandIcon={''}
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                  sx={{ backgroundColor: '#dee4ec', flexDirection: 'row-reverse', maxHeight: 'none' }}
               >
                  <Grid container sx={{ width: '100%', padding: '0px 0px', }}>
                     <Grid container xs={12} lg={12} style={{
                        position: 'relative',
                        backgroundColor: '#dee4ec',
                        width: '100%',
                        height: 'auto',
                        cursor: 'default',
                        alignItems: 'center',
                        borderTopLeftRadius: '5px',
                        borderTopRightRadius: '5px'
                     }}>
                        <Grid xs={10.5} md={11} lg={11} sx={{
                           paddingLeft: '10px',
                           fontWeight: '700',
                           width: '90%',
                           wordBreak: 'break-word',
                           fontSize: props.windowWidth < 400 ? (props.windowWidth < 340 ? '13px' : '15px') : '19px',
                        }}>
                           {
                              props.windowWidth < 400 ?
                                 <>{tierName.length > 26 ? tierName.substring(0, 26) + '...' : tierName}</>
                                 :
                                 <>{tierName.length > 36 ? tierName.substring(0, 36) + '...' : tierName}</>
                           }

                        </Grid>
                        <Grid xs={1.5} md={1} lg={1}>
                           <div style={{
                              position: 'absolute',
                              fontSize: '12px',
                              color: 'var(--brand-color)',
                              top: '10px',
                              right: '0px',
                              paddingRight: '0px'
                           }}>
                              <span style={{ cursor: 'pointer', fontWeight: '550', zIndex: '9999', padding: '5px', marginTop: '10px' }}
                                 onClick={() => {
                                    openEditTier();
                                    setTiersModal(false);
                                 }}>{t('common.edit')}</span>
                           </div>
                        </Grid>



                        <Grid xs={12}>
                           <Grid xs={12} lg={12} sx={{ width: '100%', textAlign: 'left', paddingLeft: '10px' }}>

                              {annualActive && (
                                 <span style={{ fontSize: '10px', fontWeight: '550', textAlign: 'left' }}>
                                    {currencySymbol}
                                    {async !== true ? (yearlyPrice / 100).toFixed(2) :
                                       asyncPrice2Time === '1 week' ? (yearlyPrice / 100).toFixed(2) :
                                          asyncPrice2Time === '2 weeks' ? (yearlyPrice / 100 / 2).toFixed(2) :
                                             asyncPrice2Time === '3 weeks' ? (yearlyPrice / 100 / 3).toFixed(2) :
                                                asyncPrice2Time === '4 weeks' ? (yearlyPrice / 100 / 4).toFixed(2) :
                                                   asyncPrice2Time === '6 weeks' ? (yearlyPrice / 100 / 6).toFixed(2) :
                                                      asyncPrice2Time === '8 weeks' ? (yearlyPrice / 100 / 8).toFixed(2) :
                                                         asyncPrice2Time === '10 weeks' ? (yearlyPrice / 100 / 10).toFixed(2) :
                                                            asyncPrice2Time === '12 weeks' ? (yearlyPrice / 100 / 12).toFixed(2) :
                                                               asyncPrice2Time === '1 month' ? (yearlyPrice / 100).toFixed(2) :
                                                                  asyncPrice2Time === '2 months' ? (yearlyPrice / 100 / 2).toFixed(2) :
                                                                     asyncPrice2Time === '3 months' ? (yearlyPrice / 100 / 3).toFixed(2) :
                                                                        asyncPrice2Time === '6 months' ? (yearlyPrice / 100 / 4).toFixed(2) :
                                                                           asyncPrice2Time === '1 year' ? (yearlyPrice / 100).toFixed(2) :
                                                                              asyncPrice2Time === 'forever' ? (yearlyPrice / 100).toFixed(2) : ''
                                    }

                                    {currencySymbolPost}
                                    {async !== true ? t('onboarding.setupOffering.perYearShort')
                                       : getAsyncLabel(asyncPrice2Time, props.windowWidth > 600)
                                    }</span>
                              )}

                              {monthlyActive && (
                                 <span style={{
                                    fontSize: '10px',
                                    fontWeight: '550',
                                    textAlign: 'left',
                                    paddingLeft: annualActive === true ? '8px' : '0px'
                                 }}>{currencySymbol}{(monthlyPrice / 100).toFixed(2)}{currencySymbolPost} p/m
                                 </span>
                              )}
                              <>
                                 {props.async === false &&
                                    <span style={{
                                       fontSize: '10px',
                                       fontWeight: '550',
                                       textAlign: 'left',
                                       margin: '0px 0px 0px 8px',
                                       padding: '2px 5px 2px 5px',
                                       borderRadius: '100px',
                                       color: '#FFF',
                                       backgroundColor: '#F9A600',
                                    }}>{t('dashboard.membership.membershipBadge')}</span>

                                 }
                              </>


                              {props.async === true ? <span style={{
                                 fontSize: '10px',
                                 fontWeight: '550',
                                 textAlign: 'left',
                                 margin: '0px 0px 0px 8px',
                                 padding: '2px 5px 2px 2px',
                                 borderRadius: '100px',
                                 color: '#fff',
                                 backgroundColor: 'var(--brand-color)',
                              }}> 1:1 {props.windowWidth < 600 ? '' : t('onboarding.setupOffering.coachingSupport')}</span> : ''}
                              {props.async === true && props.asyncTierHidden === true ? <span style={{
                                 fontSize: '10px',
                                 fontWeight: '550',
                                 textAlign: 'left',
                                 marginLeft: '7px',
                              }}> {t('dashboard.membership.hiddenSuffix')}</span> : ''}
                           </Grid>
                        </Grid>
                     </Grid>

                  </Grid>
               </AccordionSummary>
               <AccordionDetails sx={{
                  backgroundColor: '#eff2f6', borderBottomLeftRadius: '8px',
                  borderBottomRightRadius: '8px',
               }}>
                  <Grid container xs={12} lg={12} style={{
                     alignItems: 'flex-start',
                     justifyContent: 'flex-start',
                     backgroundColor: '#eff2f6',
                     width: '100%',
                     height: '100px',
                     paddingLeft: '0px',
                     paddingTop: '10px',
                     paddingBottom: '15px',
                     borderBottomLeftRadius: '5px',
                     borderBottomRightRadius: '5px'
                  }}>
                     {perksText.map((perk, index) => (
                        ((perk !== '') && (perk !== undefined)) ? (
                           <Grid key={index} xs={12} lg={12} sx={{ color: '#808080', fontSize: '11px' }}>
                              <span>• {decode(perk)}</span>
                           </Grid>
                        ) : (
                           <Grid key={index} xs={12} lg={12} sx={{ color: '#808080', fontSize: '11px' }}>
                              <div style={{ height: '14.5px' }}></div>
                           </Grid>
                        )
                     ))}
                  </Grid>
               </AccordionDetails>
            </Accordion></div>
      );
   };
   return (



      <>
         {isLoading ? (
            <div style={{ width: '100%', height: '100%', display: 'flex', minHeight: '300px', }}>
               <CircularProgress sx={{
                  color: 'var(--brand-color)',
                  margin: 'auto'
               }} />
            </div>
         ) :

            <Box sx={{ margin: {xs: '30px 0px 50px 0px', lg: '-30px auto 50px auto'}, height: '100%', display: 'flex', minHeight: '300px', padding: '0px 0px', flexDirection: 'column', boxSizing: 'border-box' }}>
          

               {/* TRIALS */}
               {
                  props.bronzeActive === true || props.silverActive === true || props.goldActive === true ?
                     <Grid
                        container
                        spacing={2}
                        style={{
                           boxSizing: 'border-box',
                           backgroundColor: '#FFFFFF',
                           border: '1px solid #E4EBF6',
                           borderRadius: '8px',
                           padding: '20px',
                           width: '100%',
                           margin: '0px auto 0px',
                           position: 'relative',
                        }}
                     >
                        <Grid item xs={12}>
                           <form style={{
                              backgroundColor: '#ffffff',
                              width: '100%',
                              zIndex: '10',
                           }}>
                              {props.offeringError &&
                                 <div style={{ width: '100%', marginBottom: '20px' }}>
                                    <span style={{
                                       display: 'block',
                                       color: 'var(--danger-color)',
                                       fontWeight: '600',
                                       fontSize: '15px',
                                    }}>
                                       {t('onboarding.setupOffering.maxTiersError')}
                                    </span>
                                 </div>
                              }

                              <Grid item xs={12}>
                                 <p className={'onboarding_title'} style={{
                                    fontSize: '16px',
                                    fontWeight: '600',
                                    letterSpacing: '0px',
                                    padding: '0 0 5px 0',
                                    lineHeight: '26px',
                                    textAlign: 'left'
                                 }}>
                                    {t('dashboard.membership.trials')}
                                 </p>
                                 <p className={'onboarding_description'} style={{
                                    padding: '0 0 20px 0',
                                    textAlign: 'left',
                                    fontSize: '14px'
                                 }}>
                                    {t('dashboard.membership.trialsDescription')}
                                 </p>
                                 
                                 <Typography
                                    style={{
                                       color: '#222222',
                                       fontSize: '15px',
                                       fontWeight: '600',
                                       padding: '5px 0',
                                       textAlign: 'left',
                                       display: 'flex',
                                       alignItems: 'center'
                                    }}
                                 >
                                    {t('onboarding.setupOffering.trialLength')}
                                    <DarkTooltip title={t('dashboard.membership.trialLengthTooltip')} placement="top">
                                       <span>
                                          <PiInfoBold style={{ fontSize: '18px', margin: '0 0 0 5px', color: '#222222' }} />
                                       </span>
                                    </DarkTooltip>
                                 </Typography>
                                 
                                 <FormControl
                                    hiddenLabel
                                    variant="filled"
                                    sx={{
                                       marginBottom: '10px',
                                       width: '300px',
                                       backgroundColor: '#fff',
                                       border: '0px',
                                       borderRadius: '5px',
                                       paddingTop: '0px',
                                       display: 'block',
                                       textAlign: 'left',
                                    }}
                                 >
                                    <TextField
                                       id="outlined-select-counry"
                                       select
                                       disableUnderline
                                       displayEmpty
                                       variant="filled"
                                       hiddenLabel
                                       fullWidth
                                       value={props.trialLength}
                                       onChange={(event) => {}}
                                       SelectProps={{
                                          notchedOutline: 'none',
                                          disableUnderline: true,
                                          style: {
                                             fontSize: '15px',
                                             color: 'var(--light-theme-text-color)',
                                             backgroundColor: '#fff',
                                             border: '1px solid #C7D1DE',
                                             fontWeight: '500',
                                             padding: '0px',
                                             height: '40px',
                                             paddingLeft: '10px',
                                             textAlign: 'left',
                                             borderRadius: '5px',
                                             width: '100%',
                                          },
                                          '.MuiInputBase-input-MuiFilledInput-input:focus': {
                                             backgroundColor: '#fff'
                                          },
                                       }}
                                       sx={{
                                          backgroundColor: '#fff',
                                          color: 'var(--light-theme-text-color)',
                                          padding: '0px',
                                          width: '100%',
                                          marginBottom: '10px',
                                          '.css-1003n0h-MuiSelect-select-MuiInputBase-input-MuiFilledInput-input: focus': {
                                             backgroundColor: '#fff'
                                          },
                                       }}
                                    >
                                       {trial_length_values.map(
                                          (item) => {
                                             let value = ''
                                             if (item === 0) {
                                                value = t('onboarding.setupOffering.noTrial')
                                             } else if (item === 1) {
                                                value = t('onboarding.setupOffering.dayOne', { count: 1 })
                                             } else {
                                                value = t('onboarding.setupOffering.dayOther', { count: item })
                                             }
                                             return (
                                                <MenuItem onClick={(event) => {
                                                   if (item > 0) {
                                                      setTempTrialLength(item);
                                                      setOpenTrialLengthWarning(true);
                                                   } else {
                                                      props.setTrialLength(item);
                                                      props.updateTrialLength(event, item);
                                                      props.handleCloseTiers();
                                                      props.setOfferingError(false);
                                                      props.loadTierInfo();
                                                   }
                                                }} value={item} sx={{ textAlign: 'left' }}>
                                                   {value}
                                                </MenuItem>
                                             )
                                          }
                                       )}
                                    </TextField>
                                 </FormControl>
                              </Grid>
                           </form>
                        </Grid>
                     </Grid>
                     : null
               }

               {/* FREE MEMBERSHIPS */}
               <Grid
                  container
                  spacing={2}
                  style={{
                     boxSizing: 'border-box',
                     backgroundColor: '#FFFFFF',
                     borderRadius: '8px',
                     border: '1px solid #E4EBF6',
                     padding: '20px',
                     width: '100%',
                     margin: '30px auto 0px',
                     position: 'relative',
                  }}
               >
                  <Grid item xs={12}>
                     <form style={{
                        backgroundColor: '#ffffff',
                        width: '100%',
                        zIndex: '10',
                     }}>
                        <Grid item xs={12}>
                           <p className={'onboarding_title'} style={{
                              fontSize: '16px',
                              fontWeight: '600',
                              letterSpacing: '0px',
                              padding: '0 0 5px 0',
                              lineHeight: '26px',
                              textAlign: 'left'
                           }}>
                              {t('dashboard.membership.freeMemberships')}
                           </p>
                           <p className={'onboarding_description'} style={{
                              padding: '0 0 20px 0',
                              textAlign: 'left',
                              fontSize: '14px'
                           }}>
                              {t('dashboard.membership.freeMembershipsDescription')}
                           </p>

                           <Typography
                              style={{
                                 color: '#222222',
                                 fontSize: '14px',
                                 fontWeight: '600',
                                 paddingTop: '5px',
                                 paddingBottom: props.windowWidth < 700 ? '5px' : '0px',
                                 textAlign: 'left',
                                 display: 'flex',
                                 alignItems: 'center'
                              }}
                           >
                              {t('dashboard.membership.offerFreeMemberships')}
                              <DarkTooltip title={t('dashboard.membership.offerFreeMembershipsTooltip')} placement="top">
                                 <span>
                                    <PiInfoBold style={{ fontSize: '18px', margin: '0 0 0 5px', color: '#222222' }} />
                                 </span>
                              </DarkTooltip>
                           </Typography>

                           <div style={{ display: 'flex', alignItems: 'center' }}>
                              <FormGroup sx={{ margin: '5px 0', fontWeight: '500' }}>
                                 <FormControlLabel 
                                    style={{ paddingTop: '5px', paddingBottom: '10px', marginRight: '0px', marginLeft: '-5px'}} 
                                    control={
                                       <AntSwitch
                                          checked={props.freeActive} 
                                          onChange={(event) => {
                                             props.updateFreeActive(event.target.checked);
                                          }}
                                       />
                                    }
                                    labelPlacement="end"
                                    label={
                                       <span style={{
                                          fontSize: '14px',
                                          fontWeight: '500',
                                          fontFamily: 'roboto',
                                          margin: '0px 0px 0px 10px',
                                          color: '#000',
                                       }}>
                                          {props.freeActive ? t('onboarding.yourOfferingModal.enabled') : t('onboarding.yourOfferingModal.disabled')}
                                       </span>
                                    }
                                 />
                              </FormGroup>
                           </div>
                        </Grid>
                     </form>
                  </Grid>
               </Grid>

               <Modal
                  open={openOneTierWarning}
                  onClose={() => setOpenOneTierWarning(false)}
                  aria-labelledby="modal-modal-title"
                  aria-describedby="modal-modal-description"
                  disableAutoFocus={true}
                  sx={{
                     // margin: 'auto',
                     backgroundColor: 'rgba(0,0,0,0.47)',
                     outline: '0',
                     borderRadius: '5px',
                     // overflow: 'hidden',
                     // minWidth: '50vw',
                     display: 'flex',
                     zIndex: '9999',
                     lineHeight: '25px',
                     width: '100%',
                     minHeight: '100vh',
                     maxHeight: '100vh',
                     overflow: 'scroll',
                  }}
               >

                  <Grid container justifyContent='center'
                     sx={{ paddingTop: '20px', paddingBottom: '20px', width: 'auto', borderRadius: '5px', margin: 'auto', }}>

                     <Grid
                        style={{
                           zIndex: '100',
                           justifyContent: 'flex-end',
                           alignItems: 'center',
                           padding: '30px 10px',
                           boxSizing: 'border-box',
                           width: '100vw',
                           outline: '0px',
                           maxWidth: '450px',
                           backgroundColor: 'white',
                           borderRadius: '10px',
                           height: 'auto',
                           minHeight: 'auto',
                           position: 'relative',
                        }}
                     >
                        <div style={{
                           position: 'absolute',
                           right: '-35px',
                           top: '0',
                           height: '100%',
                           width: '35px',
                           opacity: '0'
                        }}
                           onClick={() => setOpenOneTierWarning(false)} />
                        <div style={{
                           position: 'absolute',
                           left: '-35px',
                           top: '0',
                           height: '100%',
                           width: '35px',
                           opacity: '0'
                        }}
                           onClick={() => setOpenOneTierWarning(false)} />
                        <div style={{ position: 'absolute', top: '10px', right: '10px', '&:hover': { cursor: 'pointer' } }}>
                           <a onClick={() => { setOpenOneTierWarning(false); }}>
                              <IoClose className={'modal-close-icon'} />
                           </a>
                        </div>

                        <Grid container sx={{ justifyContent: "center", alignItems: "center", display: "flex", zIndex: '1000', }}>


                           <div style={{ width: '100%', display: 'block', margin: '10px 0px', marginBottom: '0px' }}>
                              <h3 style={{ fontSize: '28px', margin: '10px auto 0px auto', textAlign: 'center' }}>🧐</h3>
                              <h3 style={{ margin: '20px auto', textAlign: 'center' }}>{t('onboarding.setupOffering.additionalTierTitle')}</h3>
                              <p className={'onboarding_description'} style={{
                                 padding: '0px 0px 10px 0px', fontWeight: '500', width: '100%', margin: '10px auto 5px auto', maxWidth: '300px', minWidth: '300px', textAlign: 'left',
                              }}>{t('onboarding.setupOffering.additionalTierDescription')}
                              </p>
                           </div>

                           <Button variant="contained" onClick={() => {
                              setOpenOneTierWarning(false);
                              props.openAddNewTier(false);
                              props.setTiersModal(false);
                           }} disableElevation
                              sx={{
                                 padding: '5px 25px',
                                 width: props.windowWidth < 360 ? '100%' : '160px',
                                 textAlign: 'center',
                                 display: 'inline-block',
                                 margin: '5px 5px',
                                 marginTop: '10px',
                                 borderRadius: '10px',
                                 textTransform: 'none',
                                 border: '2px var(--brand-color) solid',
                                 color: 'var(--brand-color)',
                                 backgroundColor: 'white',
                                 '&:hover': {
                                    backgroundColor: 'white',
                                    border: '2px var(--brand-color-hover) solid',
                                 }
                              }}>
                              <span className="fa fa-search"
                                 style={{ fontWeight: '600', fontSize: '16px' }}>{t('onboarding.setupOffering.addTier')}</span>
                           </Button>
                           <Button variant="contained" onClick={() => { setOpenOneTierWarning(false); }} disableElevation
                              sx={{
                                 padding: '5px 25px',
                                 width: props.windowWidth < 360 ? '100%' : '160px',
                                 textAlign: 'center',
                                 display: 'inline-block',
                                 margin: '5px 5px',
                                 borderRadius: '10px',
                                 textTransform: 'none',
                                 border: '2px var(--brand-color) solid',
                                 backgroundColor: 'var(--brand-color)',
                                 marginTop: '10px',
                                 '&:hover': {
                                    backgroundColor: 'var(--brand-color-hover)',
                                    border: '2px var(--brand-color-hover) solid',
                                 }
                              }}>
                              <span className="fa fa-search"
                                 style={{ fontWeight: '600', fontSize: '16px' }}>{t('onboarding.setupOffering.goBack')}</span>
                           </Button>

                        </Grid>
                     </Grid>
                  </Grid>
               </Modal>

               <Modal
                  open={openTrialLengthWarning}
                  onClose={() => setOpenTrialLengthWarning(false)}
                  aria-labelledby="modal-modal-title"
                  aria-describedby="modal-modal-description"
                  disableAutoFocus={true}
                  sx={{
                     // margin: 'auto',
                     backgroundColor: 'rgba(0,0,0,0.47)',
                     outline: '0',
                     borderRadius: '5px',
                     // overflow: 'hidden',
                     // minWidth: '50vw',
                     display: 'flex',
                     zIndex: '9999',
                     lineHeight: '25px',
                     width: '100%',
                     minHeight: '100vh',
                     maxHeight: '100vh',
                     overflow: 'scroll',
                  }}
               >

                  <Grid container justifyContent='center'
                     sx={{ paddingTop: '20px', paddingBottom: '20px', width: 'auto', borderRadius: '5px', margin: 'auto', }}>

                     <Grid
                        style={{
                           zIndex: '100',
                           justifyContent: 'flex-end',
                           alignItems: 'center',
                           padding: '30px 10px',
                           boxSizing: 'border-box',
                           width: '100vw',
                           outline: '0px',
                           maxWidth: '450px',
                           backgroundColor: 'white',
                           borderRadius: '10px',
                           height: 'auto',
                           minHeight: 'auto',
                           position: 'relative',
                        }}
                     >
                        <div style={{
                           position: 'absolute',
                           right: '-35px',
                           top: '0',
                           height: '100%',
                           width: '35px',
                           opacity: '0'
                        }}
                           onClick={() => setOpenTrialLengthWarning(false)} />
                        <div style={{
                           position: 'absolute',
                           left: '-35px',
                           top: '0',
                           height: '100%',
                           width: '35px',
                           opacity: '0'
                        }}
                           onClick={() => setOpenTrialLengthWarning(false)} />

                        <div style={{ position: 'absolute', top: '10px', right: '10px', '&:hover': { cursor: 'pointer' } }}>
                           <a onClick={() => { setOpenTrialLengthWarning(false); }}>
                              <IoClose className={'modal-close-icon'} />
                           </a>
                        </div>

                        <Grid container sx={{ justifyContent: "center", alignItems: "center", display: "flex", zIndex: '1000', }}>

                           <div style={{ width: '100%', display: 'block', margin: '10px 0px', marginBottom: '0px' }}>
                              <h3 style={{ fontSize: '28px', margin: '10px auto 0px auto', textAlign: 'center' }}>✨</h3>
                              <h3 style={{ margin: '20px auto', textAlign: 'center' }}>{t('onboarding.setupOffering.trialPeriodTitle')}</h3>
                              <p className={'onboarding_description'} style={{
                                 padding: '0px 0px 10px 0px', fontWeight: '500', width: '100%', margin: '10px auto 5px auto', maxWidth: '300px', minWidth: '300px', textAlign: 'left',
                              }}>{t('onboarding.setupOffering.trialPeriodDescription')}
                              </p>
                           </div>
                           <Button variant="contained" onClick={(e) => {
                              setOpenTrialLengthWarning(false);
                              props.setTrialLength(tempTrialLength);
                              props.updateTrialLength(e, tempTrialLength);
                              props.handleCloseTiers();
                              props.setOfferingError(false);
                              props.loadTierInfo();
                           }} disableElevation
                              sx={{
                                 padding: '5px 25px',
                                 width: '160px',
                                 textAlign: 'center',
                                 display: 'inline-block',
                                 margin: '5px 5px',
                                 borderRadius: '10px',
                                 textTransform: 'none',
                                 border: '2px var(--brand-color) solid',
                                 backgroundColor: 'var(--brand-color)',
                                 marginTop: '10px',
                                 '&:hover': {
                                    backgroundColor: 'var(--brand-color-hover)',
                                    border: '2px var(--brand-color-hover) solid',
                                 }
                              }}>
                              <span className="fa fa-search"
                                 style={{ fontWeight: '600', fontSize: '16px' }}>{t('onboarding.setupOffering.addTrial')}</span>
                           </Button>
                           <Button variant="contained" onClick={(e) => {
                              setOpenTrialLengthWarning(false);
                              props.setTrialLength(0);
                              props.updateTrialLength(e, 0);
                              props.handleCloseTiers();
                              props.setOfferingError(false);
                              props.loadTierInfo();
                           }} disableElevation
                              sx={{
                                 padding: '5px 25px',
                                 width: '160px',
                                 textAlign: 'center',
                                 display: 'inline-block',
                                 margin: '5px 5px',
                                 marginTop: '10px',
                                 borderRadius: '10px',
                                 textTransform: 'none',
                                 border: '2px var(--brand-color) solid',
                                 color: 'var(--brand-color)',
                                 backgroundColor: 'white',
                                 '&:hover': {
                                    backgroundColor: 'white',
                                    border: '2px var(--brand-color-hover) solid',
                                 }
                              }}>
                              <span className="fa fa-search"
                                 style={{ fontWeight: '600', fontSize: '16px' }}>{t('onboarding.setupOffering.skipTrial')}</span>
                           </Button>

                        </Grid>
                     </Grid>
                  </Grid>
               </Modal>
            </Box>

         }

      </>

   )
}
